import $ from 'jquery'
import Vue from 'vue'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import QuickBuy from './components/QuickBuy.vue'

const QuickBuyVue = () => {
    return new Vue({
        el: '#quick-buy-container',
        data: {
            debug: true,
            isOpen: false,
            strings: window.PlUs.strings,
            skuSelected: null,
            isWishlist: false,
            product: {
                name: '',
                description: '',
                currency: '',
                images: [],
                price: '',
                lower_price:'',
                original_price:'',
                discountPercentageLowerPrice:'',
                discountPercentageOriginalPrice:'',
                priceListId: '',
                priceList:'',
                discountPrice: '',
                discount: false,
                singleSku: true,
                skus: null,
            }
        },
        components: {
            'quick-buy': QuickBuy
        },
        watch: {
            isOpen: function (nextVal) {
                if(nextVal) {
                    $('body').addClass('no-scroll')
                } else {
                    $('body').removeClass('no-scroll')
                }
            },
        },
        methods: {
            open(productVersion) {
                window.axios.get(window.PlUs.api.cart+'/'+productVersion)
                .then((response) => {
                    if(process.env.NODE_ENV === "development") {
                        console.log(response);
                    }
                    if(response.data.data.status == false && response.data.data.empty == true) {
                        Swal.fire({
                            icon: 'info',
                            title: 'Il prodotto è esaurito', // todo tradurre
                            text: 'Siamo spiacenti ma questo prodotto è momentaneamente esaurito', // todo tradurre
                        })
                    } else {
                        this.product = response.data.data.product
                        this.isOpen = true
                    }
                }).catch((err) => {
                    console.error(err)
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: this.strings['error'],
                        footer: err
                    })
                })
            },
            close() {
                this.isOpen = false
            },
            reset() {
                this.product = {
                    name: '',
                    description: '',
                    currency: '',
                    images: [],
                    price: '',
                    lower_price:'',
                    original_price:'',
                    discountPercentageLowerPrice:'',
                    discountPercentageOriginalPrice:'',
                    priceListId:'',
                    priceList:'',
                    basePrice: '',
                    discount: false,
                    singleSku: true,
                    skus: null,
                }
            }
        },
        created() {
            $('.quick-buy').on('click', (event) => {
                event.preventDefault()
                event.stopPropagation()
                this.isWishlist = false
                this.reset()
                this.open(event.currentTarget.dataset.product)

                //GA4
                dataLayer.push ({
                    'event': 'quick buy',
                    'event_detail': window.location.pathname
                   });
                // new Swiper('.qb-container .swiper-container', {
                //     preloadImages: false,
                //     lazyLoading: true,
                //     pagination: '.qb-container .swiper-pagination',
                //     paginationClickable: true,
                // });
            })

            $('.wish-list').on('click', (event) => {
                event.preventDefault()
                event.stopPropagation()
                this.isWishlist = true
                this.reset()
                this.open(event.currentTarget.dataset.product)

                // this.sliderWhisList =  new Swiper('.swiper-container--quick', {
                //     loop: true,
                //     pagination: {
                //         el: '.swiper-pagination--quick',
                //     },
                //     direction: 'horizontal',
                // });
            })
        }
    })
}

export default QuickBuyVue
